import { ProductSearchParams, ProductSortField } from '../product.model'
import { QueryStringSort } from '../../../models/query-string.model'

// Datagrid

export function productSortParams(
  params: ProductSearchParams,
  sort: QueryStringSort<ProductSortField>,
): ProductSearchParams {
  const searchParams: ProductSearchParams = {}

  switch (sort.field) {
    case 'createdAt':
      searchParams.sort = 'createdAt'
      searchParams.order = sort.order
      break
    case 'updatedAt':
      searchParams.sort = 'updatedAt'
      searchParams.order = sort.order
      break
    case 'SKU':
      searchParams.sort = 'SKU'
      searchParams.order = sort.order
      break
    case 'name':
      searchParams.sort = 'name'
      searchParams.order = sort.order
      break
    case 'maxProvisions':
      searchParams.sort = 'maxProvisions'
      searchParams.order = sort.order
      break
    case 'minProvisions':
      searchParams.sort = 'minProvisions'
      searchParams.order = sort.order
      break
    case 'netWeight':
      searchParams.sort = 'netWeight'
      searchParams.order = sort.order
      break
    case 'grossWeight':
      searchParams.sort = 'grossWeight'
      searchParams.order = sort.order
      break
    case 'abcClass':
      searchParams.sort = 'abcClass'
      searchParams.order = sort.order
      break
    case 'volume.total':
      searchParams.sort = 'volume.total'
      searchParams.order = sort.order
      break
    case 'price.purchase':
      searchParams.sort = 'price.purchase'
      searchParams.order = sort.order
      break
    case 'price.listing':
      searchParams.sort = 'price.listing'
      searchParams.order = sort.order
      break
    case 'price.discount':
      searchParams.sort = 'price.discount'
      searchParams.order = sort.order
      break
    case 'onHandQty':
      searchParams.sort = 'onHandQty'
      searchParams.order = sort.order
      break
    case 'availableQty':
      searchParams.sort = 'availableQty'
      searchParams.order = sort.order
      break
    case 'incomingQty':
      searchParams.sort = 'incomingQty'
      searchParams.order = sort.order
      break
    case 'receivingQty':
      searchParams.sort = 'receivingQty'
      searchParams.order = sort.order
  }

  if (sort.field.match(/^(attributes.)/g)) {
    searchParams.sort = sort.field
    searchParams.order = sort.order
  }

  return {
    ...params,
    ...searchParams,
  }
}
